exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-size: 1.5em;\n  margin-bottom: 8px; }\n\n.field {\n  margin-top: 16px;\n  display: -ms-flexbox;\n  display: flex; }\n  .field button {\n    margin-left: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/home/disclaimer/disclaimer.component.scss
// module id = ../../../../../src/app/home/disclaimer/disclaimer.component.scss
// module chunks = 1